module.exports = __webpack_public_path__ + "static/media/patients.47c30116.png";